<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import Header from '@components/header.vue'
import router from '@router/index'
import storageService from '../../services/storage.service'
import { store } from '../../state/store'
import { phoneNumbers } from '../../models/enums'

export default {
  page: {
    title: 'Job Complete',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Header },
  props: {
    confirmationNumber: {
      default: null,
      type: String,
    },
  },
  data: function() {
    return {
      GENERAL_PHONE_NUMBER: phoneNumbers.GENERAL,
    }
  },
  beforeDestroy() {
    store.unloadState()
    storageService.removeJob()
    storageService.removeTwoWayTestState()
    router.push('/')
  },
}
</script>

<template>
  <Layout>
    <Header />
    <div :class="$style.parent_container">
      <div class="m-3 text-center">
        <h1 :class="$style.job_confirmation">JOB COMPLETE</h1>
      </div>

      <div :class="$style.job_confirmation_number_card" class="text-center">
        <div :class="$style.job_confirmation_label">
          CONFIRMATION NUMBER
        </div>
        <div>
          <div :class="$style.job_confirmation_number_card_body" class="row">
            <div class="text-center col-1"
              ><svg class="btn__icon icon-4 icon-check text-white">
                <use
                  xlink:href="../../assets/images/brinkshome_icons.svg#icon-check"
                ></use>
              </svg>
            </div>
            <div :class="$style.confirmation_number" class="text-center col-10">
              <span>{{ confirmationNumber }}</span>
            </div>
          </div></div
        >
      </div>
      <div :class="$style.phone_number_message"
        >If you need to provide additional job information, call
        <a :href="'tel:' + GENERAL_PHONE_NUMBER">{{
          GENERAL_PHONE_NUMBER
        }}</a></div
      >
      <div :class="$style.job_confirmation_text" class="text-center">
        <p
          >Please write down the confirmation number. You will not be able to
          access it again.</p
        >
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.phone_number_message {
  width: 85%;
  margin: auto;
}

.confirmation_number {
  align-self: center;
}

.job_confirmation {
  margin-top: 0;
  font-weight: 900;
  color: $color-text-primary;
}

.job_confirmation_text {
  padding: 3em;
  padding-top: 0.25em;
  margin-top: 1em;
  font-family: $system-default-font-family;
  font-weight: 600;
  color: $color-text-primary;
}

.job_confirmation_label {
  font-family: $system-default-font-family;
  font-weight: 600;
  line-height: 2em;
  color: white;
  background-color: $color-text-primary;
  width: 100%;
}

.job_confirmation_number_card {
  width: 95%;
  margin: auto;
  -webkit-box-shadow: 0px 5px 10px -7px #000000,
    5px 5px 10px 5px rgba(0, 0, 0, 0);
  box-shadow: 0px 5px 10px -7px #000000, 5px 5px 10px 5px rgba(0, 0, 0, 0);
}

.job_confirmation_number_card_body {
  padding-top: 3em;
  padding-right: 2em;
  padding-bottom: 3em;
  padding-left: 2em;
  font-weight: 600;
  color: $color-text-primary;
  background-color: $color-highlighted-body-bg;
  width: 100%;
}

.parent_container {
  position: relative;
  top: $height-status-bar;
  max-width: $size-parent-container-width-max;
  margin: auto;
  text-align: center;
}

.phone_number_message > a {
  color: $color-text-primary;
}

.phone_number_message > a:visited {
  color: $color-text;
}
</style>
